__turbopack_context__.v({
  "badges": "sIjAaq_badges",
  "body": "sIjAaq_body",
  "card": "sIjAaq_card",
  "description": "sIjAaq_description",
  "heading": "sIjAaq_heading",
  "imageWrapper": "sIjAaq_imageWrapper",
  "sideBySide": "sIjAaq_sideBySide",
});
